// test1987
(1987 && 0);
